"use client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@/redux/store";
import { patchPerformanceMeasureForDev } from "@/lib/dev/patchPerformanceMeasure";

if (typeof window !== "undefined") {
  patchPerformanceMeasureForDev();
}

export default function ReduxProvider({ children }: { children: React.ReactNode }) {

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
}